/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/Content/Completed/LaunchIteroAction/Content",
  isSubmitting
  
}) {
let iteroScanIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'itero_scan',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isSubmitting
  
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 block={true}
 data="itero_scan"
 onClick={onClick}
 disabled={iteroScanIsSubmittingData}
 marginRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="View images in My iTero™"
 marginRight={dtSpaceXs}
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2Launch
{...childProps}
  viewPath={`${viewPath}/Tysiav2Launch`}
 width={16}
 height={16}
 marginLeft="auto"
 stroke={dtColorsNeutral500}
 fill={dtColorsWhite}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}